import { IONICWrapper } from "../common";

export const RemoteConfigDataStore = async (remoteConfig: any) => {
  let allData = await remoteConfig.getAll();
  Object.entries(allData).forEach(([_key, value]: any) => {
    let _value = value._value;
    try {
      let parsedValue = _value && JSON.parse(_value);
      Object.entries(parsedValue).forEach(([key, value]: any) => {
        IONICWrapper.details.setKeyValuePairs = { [key]: value };
      });
    } catch {
      console.error("Parshing issue on remote config data");
    }
  });
};
